import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { inputStyles } from "../styles/styles";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import InfoIcon from "@material-ui/icons/Info";
import { Box, Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getInsuranceOffer,
  getSimulation,
  getTarifeOffer,
} from "../store/limitAndPaymentInformation/thunkActions";
import { updateAlert } from "../store/alert/actions";
import { getNumberFormat } from "../utils/enums";
import { PaymentPlanColumns } from "./columns/paymentPlanColumns";
import { GuarantorListColumns } from "./columns/guarantorListColumns";
import { updateLimitAndPaymentInfo } from "../store/limitAndPaymentInformation/actions";
import { TarifeeColumns } from "./columns/tarifeeColumns";
import { addProcessContext } from "../store/processContext/actions";
import { LimitAllocationCommColumns } from "./columns/limitAllocationCommColumns";
import { getTransferContent } from "../utils/transferContent";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const paymentPlanColumns = PaymentPlanColumns();
const guarantorListColumns = GuarantorListColumns();
const tarifeeColumns = TarifeeColumns();
const limitAllocationCommColumns = LimitAllocationCommColumns();

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const DataGridTitle = (props) => {
  return (
    <Box
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Typography variant="h5">{props.header}</Typography>
    </Box>
  );
};

function PaymentPlanDialog(props) {
  const [open, setOpen] = React.useState(false);

  const classes = inputStyles();

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    let body = {
      creditAmount: props.creditAmount,
      installmentNumber: props.selectedInterestRate?.installmentNumber,
      externalId: props.uuid,
      interestRateId: props.selectedInterestRate?.interestRateId,
    };

    if (
      !props.selectedInterestRate?.creditAmount &&
      !props.selectedInterestRate?.installmentNumber
    ) {
      props.actions.updateAlert({
        severity: "error",
        text: "Kredi tutarı ve taksit sayısı seçiniz.",
        open: true,
      });
      return;
    }

    try {
      const creditAmountFloat = parseFloat(props.creditAmount);
      const usableAmountFloat = parseFloat(
        props.selectedInterestRate?.usableAmount
      );
      const minAmountFloat = parseFloat(props.selectedInterestRate?.minAmount);

      if (creditAmountFloat > usableAmountFloat) {
        props.actions.updateAlert({
          severity: "error",
          text:
            "Bu paketten " +
            getNumberFormat(props?.selectedInterestRate?.usableAmount) +
            "₺ kadar kullandırım yapabilirsiniz. Kullandırım tutarını güncelleyerek tekrar deneyin.",
          open: true,
        });
        return;
      }
      if (creditAmountFloat < minAmountFloat) {
        props.actions.updateAlert({
          severity: "error",
          text:
            "Bu paketten minimum " +
            getNumberFormat(props?.selectedInterestRate?.minAmount) +
            "₺ kadar kullandırım yapabilirsiniz. Kullandırım tutarını güncelleyerek tekrar deneyin.",
          open: true,
        });
        return;
      }
    } catch (err) {}
    if (
      props.selectedInterestRate?.insuranceFlag === "3" &&
      props.selectedInterestRate?.insuranceSelection === "Seçiniz"
    ) {
      props.actions.updateAlert({
        severity: "error",
        text: "Sigorta seçeneğini seçiniz.",
        open: true,
      });
      return;
    }
    if (props.selectedInterestRate?.insuranceSelection === "Evet") {
      props.actions
        .getInsuranceOffer({
          creditAmount: props.creditAmount,
          externalId: props.uuid,
          interestRateId: props.selectedInterestRate?.interestRateId,
          installmentNumber: props.selectedInterestRate?.installmentNumber,
        })
        .then((ress) => {
          props.actions
            .getSimulation({
              ...body,
              hasInsurance: ress?.insuranceDecision === "OK" ? "1" : "0",
            })
            .then(() => {
              if (
                props.selectedInterestRate?.tarifeFlag &&
                props.selectedInterestRate?.tarifeFlag !== "0"
              ) {
                props.actions
                  .getTarifeOffer({
                    creditAmount: props.creditAmount,
                    externalId: props.uuid,
                    interestRateId: props.selectedInterestRate?.interestRateId,
                  })
                  .then((ress) => {});
              }
              setOpen(true);
            });
        });
    } else {
      props.actions
        .getSimulation({
          ...body,
          hasInsurance: "0",
        })
        .then(() => {
          setOpen(true);
          if (
            props.selectedInterestRate?.tarifeFlag &&
            props.selectedInterestRate?.tarifeFlag !== "0"
          ) {
            props.actions
              .getTarifeOffer({
                creditAmount: props.creditAmount,
                externalId: props.uuid,
                interestRateId: props.selectedInterestRate?.interestRateId,
              })
              .then((ress) => {});
          }
        });
    }

    /*props.actions.getSimulation(body).then((res) => {
      if (res === true) {
        props.actions.addProcessContext({
          limitType: props.selectedInterestRate?.limitType,
        });
        if (props.selectedInterestRate?.insuranceSelection === "Evet") {
          props.actions
            .getInsuranceOffer({
              creditAmount: props.creditAmount,
              externalId: props.uuid,
              interestRateId: props.selectedInterestRate?.interestRateId,
              installmentNumber: props.selectedInterestRate?.installmentNumber,
            })
            .then((ress) => {
              if (
                props.selectedInterestRate?.tarifeFlag &&
                props.selectedInterestRate?.tarifeFlag !== "0"
              ) {
                props.actions
                  .getTarifeOffer({
                    creditAmount: props.creditAmount,
                    externalId: props.uuid,
                    interestRateId: props.selectedInterestRate?.interestRateId,
                  })
                  .then((ress) => {});
              }
            });
        } else {
          if (
            props.selectedInterestRate?.tarifeFlag &&
            props.selectedInterestRate?.tarifeFlag !== "0"
          ) {
            props.actions
              .getTarifeOffer({
                creditAmount: props.creditAmount,
                externalId: props.uuid,
                interestRateId: props.selectedInterestRate?.interestRateId,
              })
              .then((ress) => {});
          }
          props.actions.updateLimitAndPaymentInfo({ insuranceOffer: null });
        }
        setOpen(true);
      }
    });
    */
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={handleClickOpen}
        size="small"
        className={classes.button}
      >
        Ödeme Planını Oluştur
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        maxWidth={"lg"}
        fullWidth
        fullScreen={fullScreen}
        scroll="paper"
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Örnek Ödeme Planınız
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={4}>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Card style={{ width: "100%", textAlign: "center" }}>
                <CardContent>
                  <Typography
                    style={{ fontSize: 15 }}
                    color="textSecondary"
                    gutterBottom
                  >
                    Kredi Tutarı
                  </Typography>
                  <Typography variant="h5" component="h2">
                    {getNumberFormat(props.creditAmount)} TL
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Card style={{ width: "100%", textAlign: "center" }}>
                <CardContent>
                  <Typography
                    style={{ fontSize: 15 }}
                    color="textSecondary"
                    gutterBottom
                  >
                    Ödeme / Taksit Adedi
                  </Typography>
                  <Typography variant="h5" component="h2">
                    {props.selectedInterestRate?.installmentNumber}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            {props.limitAndPaymentInformation?.paymentPlanData
              ?.sumCreditAmount !== props.creditAmount && (
              <Grid item xs={12} md={3}>
                <Card style={{ width: "100%", textAlign: "center" }}>
                  <CardContent>
                    <Typography
                      style={{ fontSize: 15 }}
                      color="textSecondary"
                      gutterBottom
                    >
                      Sigorta Dahil Kredi Tutarı
                    </Typography>
                    <Typography variant="h5" component="h2">
                      {getNumberFormat(
                        props.limitAndPaymentInformation?.paymentPlanData
                          ?.sumCreditAmount
                      )}{" "}
                      TL
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            )}

            <Grid
              item
              xs={12}
              md={3}
            >
              <Card style={{ width: "100%", textAlign: "center" }}>
                <CardContent>
                  <Typography
                    style={{ fontSize: 15 }}
                    color="textSecondary"
                    gutterBottom
                  >
                    Geri Ödeme Tutarı
                  </Typography>
                  <Typography variant="h5" component="h2">
                    {getNumberFormat(
                      props.limitAndPaymentInformation?.paymentPlanData
                        ?.refundAmount
                    )}{" "}
                    TL
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={3}>
              <Card style={{ width: "100%", textAlign: "center" }}>
                <CardContent>
                  <Typography
                    style={{ fontSize: 15 }}
                    color="textSecondary"
                    gutterBottom
                  >
                    {
                      getTransferContent(
                        props.processContext?.doTransferToCompany
                      ).originalNetAmountLabel
                    }
                  </Typography>
                  <Typography variant="h5" component="h2">
                    {props.limitAndPaymentInformation?.paymentPlanData
                      ?.originalNetAmount !== undefined &&
                    props.limitAndPaymentInformation?.paymentPlanData
                      ?.originalNetAmount !== null
                      ? `${getNumberFormat(
                          props.limitAndPaymentInformation.paymentPlanData
                            .originalNetAmount
                        )} TL`
                      : "-"}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            {props.selectedInterestRate?.paymentFreePeriod !== "" &&
              props.selectedInterestRate?.paymentFreePeriod !== "0" &&
              props.productType === "0" && (
                <Grid container>
                  <Grid item xs={12}>
                    <div
                      style={{
                        display: "flex",
                        marginTop: 15,
                        marginBottom: 15,
                      }}
                    >
                      <InfoIcon
                        fontSize="small"
                        color="disabled"
                        style={{ marginRight: 5 }}
                      />
                      <div className={classes.informationLabel}>
                        {
                          props.limitAndPaymentInformation?.paymentPlanData
                            ?.paymentFreePeriodExp
                        }
                      </div>
                    </div>
                  </Grid>
                </Grid>
              )}

            <Grid item xs={12}>
              <h4 style={{ textAlign: "center" }}>Ödeme Planı</h4>
              <Box
                style={{
                  maxHeight: "60dvh",
                  overflowY: "auto",
                  minHeight: 0,
                }}
              >
                <DataGrid
                  rows={
                    props.limitAndPaymentInformation?.paymentPlanData
                      ?.paymentPlan
                      ? props.limitAndPaymentInformation.paymentPlanData
                          ?.paymentPlan
                      : []
                  }
                  columns={paymentPlanColumns}
                  hideFooter
                  density="compact"
                  autoHeight={true}
                  disableColumnMenu={true}
                  disableColumnFilter={true}
                  disableColumnSelector={true}
                  style={{ fontSize: 12 }}
                />
              </Box>
            </Grid>

            <Grid item container xs={12} spacing={2}>
              {props.selectedInterestRate?.insuranceSelection === "Evet" && (
                <Grid item xs={12} md={4}>
                  <h4 style={{ textAlign: "center" }}>Sigorta Bilgileri</h4>
                  <DataGrid
                    rows={
                      props.limitAndPaymentInformation.insuranceOffer
                        ?.totalAmount
                        ? [
                            {
                              id: 0,
                              collateral: "Brüt Prim",
                              amount:
                                props.limitAndPaymentInformation.insuranceOffer
                                  ?.totalAmount,
                            },
                          ]
                        : []
                    }
                    columns={guarantorListColumns}
                    pageSize={5}
                    hideFooter
                    density="compact"
                    autoHeight={true}
                    hideFooterPagination={true}
                    disableColumnMenu={true}
                    disableColumnFilter={true}
                    disableColumnSelector={true}
                    style={{ fontSize: 12 }}
                    components={{ Toolbar: DataGridTitle }}
                    componentsProps={{
                      Toolbar: { header: "Sigorta Bilgileri" },
                    }}
                  />
                </Grid>
              )}

              {Number(
                props.limitAndPaymentInformation?.paymentPlanData
                  ?.limitAllocationCommAmount
              ) > 0 && (
                <Grid item xs={12} md={4}>
                  <h4 style={{ textAlign: "center" }}>Kredi Tahsis Ücreti</h4>
                  <DataGrid
                    rows={[
                      {
                        id: 0,
                        amount:
                          props.limitAndPaymentInformation?.paymentPlanData
                            ?.limitAllocationCommAmount,
                      },
                    ]}
                    columns={limitAllocationCommColumns}
                    pageSize={5}
                    hideFooter
                    density="compact"
                    autoHeight={true}
                    hideFooterPagination={true}
                    disableColumnMenu={true}
                    disableColumnFilter={true}
                    disableColumnSelector={true}
                    style={{ fontSize: 12 }}
                  />
                </Grid>
              )}

              {props.selectedInterestRate?.tarifeFlag !== "0" && (
                <Grid item xs={12} md={4}>
                  <h4 style={{ textAlign: "center" }}>Tarife Bilgileri</h4>
                  <DataGrid
                    rows={
                      props.limitAndPaymentInformation.tarifeOffer
                        ?.commissionPackName
                        ? [
                            {
                              id: 0,
                              commissionPackName:
                                props.limitAndPaymentInformation.tarifeOffer
                                  .commissionPackName,
                              commissionPackPrice:
                                props.limitAndPaymentInformation.tarifeOffer
                                  ?.commissionPackPrice,
                            },
                          ]
                        : []
                    }
                    columns={tarifeeColumns}
                    pageSize={5}
                    hideFooter
                    density="compact"
                    autoHeight={true}
                    hideFooterPagination={true}
                    disableColumnMenu={true}
                    disableColumnFilter={true}
                    disableColumnSelector={true}
                    style={{ fontSize: 12 }}
                  />
                </Grid>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            color="primary"
            onClick={handleClose}
            size="small"
            className={classes.button}
          >
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    limitAndPaymentInformation: state.limitAndPaymentInformation,
    processContext: state.processContext,
    alert: state.alert,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getSimulation: bindActionCreators(getSimulation, dispatch),
      getInsuranceOffer: bindActionCreators(getInsuranceOffer, dispatch),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      getTarifeOffer: bindActionCreators(getTarifeOffer, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      updateLimitAndPaymentInfo: bindActionCreators(
        updateLimitAndPaymentInfo,
        dispatch
      ),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentPlanDialog);
